import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import IndexEn from './views/IndexEn.vue'
import PoliticaDeConfidentialitate from './views/PoliticaDeConfidentialitate.vue';
import PoliticaDeCookies from './views/PoliticaDeCookies.vue'
import TermeniSiConditii from './views/TermeniSiConditii.vue'
Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },  
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: 'eematico Toys',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys'
          },
          {
            property: 'og:description',
            content: 'eematico Toys'
          }
        ]  
        }    
    },
    {
      path: '/en',
      name: 'indexEn',
      component: IndexEn,
      meta: {
        title: 'eematico Toys',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys'
          },
          {
            property: 'og:description',
            content: 'eematico Toys'
          }
        ]      
      }
    },    
    {
      path:'/politica-de-confidentialitate',
      name:'politica-de-confidentialitate',
      component: PoliticaDeConfidentialitate,
      meta: {
        title: 'eematico Toys',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys'
          },
          {
            property: 'og:description',
            content: 'eematico Toys'
          }
        ]       
      }
    },
    {
      path:'/politica-de-cookies',
      name:'politica-de-cookies',
      component: PoliticaDeCookies,
      meta: {
        title: 'eematico Toys',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys'
          },
          {
            property: 'og:description',
            content: 'eematico Toys'
          }
        ]       
      }
    },
    {
      path:'/termeni-si-conditii',
      name:'termeni-si-conditii',
      component: TermeniSiConditii,
      meta: {
        title: 'eematico Toys',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys'
          },
          {
            property: 'og:description',
            content: 'eematico Toys'
          }
        ]       
      }
    }
    

    // {
    //   path: '/en',
    //   name: 'about',
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
  ]
})
